module.exports = __webpack_public_path__ + "static/media/guide_notice_banner.d8a7d4c6.jpg";